export default __webpack_public_path__ + "static/media/MonthlyReportinactiveLight.81608fec.svg";